export class Idel2TranslatorClient {
    static BASE_URL = '/lectura-translator-api/v1/results';

    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    getRequestHeaders = (token = '', staffId = '') => ({
        ...(token && { authorization: `Bearer ${token}` }),
        ...(staffId && { staff: staffId }),
    });

    /**
     * Get Idel2 results, student statuses.
     * @param {Array<String>} studentUids List of student ids. Should be not empty.
     * @param {Number} [schoolYear] School year to get results. If not provided, all years are included. This value must be equal or bigger than 2020.
     * @param {String} [classId=undefined] If set, API response would contain students results that were created in specified class.
     * @param {Boolean} [includeInvalidated=true] If true, invalidated results for all measures are included
     * @param {Boolean} [withCroppedResults=true] If true, result details for FSS measure are in cropped format
     * @param {Boolean} [withZog=true] If true, zones of growth data for each student is included
     * @param {String}  token - keycloak token for API authorization
     * @param {String} staffId - staffId for an additional header used in results caching.
     * @returns {Promise}
     */
    async getResults(
        studentUids,
        schoolYear,
        classId,
        includeInvalidated = true,
        withCroppedResults = true,
        withZog = true,
        token,
        staffId = '',
    ) {
        const headers = this.getRequestHeaders(token, staffId);

        return this.httpClient.get(Idel2TranslatorClient.BASE_URL, {
            params: {
                studentUids: studentUids.join(','),
                schoolYear,
                classId,
                includeInvalidated,
                withCroppedResults,
                withZog,
            },
            headers,
        });
    }
}

export default Idel2TranslatorClient;
